<template>
  <div>
    <div class="text-subtitle-1">
      This schedule overlaps with {{ overlappingSchedules.length }} schedule(s)
    </div>
    <div>
      <v-list>
        <v-list-item-group>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Name</v-list-item-subtitle>
              <v-list-item-title>
                <span v-if="student">
                  {{ student.firstName }} {{ student.lastName }}
                </span>
                <span v-if="teacher">
                  {{ teacher.firstName }} {{ teacher.lastName }}
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Start Date</v-list-item-subtitle>
              <v-list-item-title>{{
                schedule.startDate | formatDate
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="schedule.recurring">
            <v-list-item-content>
              <v-list-item-subtitle>End Date</v-list-item-subtitle>
              <v-list-item-title>
                <span v-if="schedule.endDate">
                  {{ schedule.endDate | formatDate }}
                </span>
                <span v-else> No end date </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Start Time</v-list-item-subtitle>
              <v-list-item-title>{{ schedule.startTime }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>End Time</v-list-item-subtitle>
              <v-list-item-title>{{ schedule.endTime }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="schedule.recurring">
            <v-list-item-content>
              <v-list-item-subtitle>Recurring Days</v-list-item-subtitle>
              <v-list-item-title>{{
                schedule.daysOfWeek.join(", ")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>

    <v-divider class="my-4"></v-divider>
    <div>Overlaps with the following schedules</div>
    <div
      class="my-4"
      v-for="overlap in overlappingSchedules"
      :key="overlap.scheduleId"
    >
      <v-divider class="my-4"></v-divider>

      <div class="d-flex justify-space-between mb-2">
        <span> Schedule ID: {{ overlap.scheduleId }} </span>
        <span>
          {{ overlap.overlappingDates.length }}
          Overlaps
        </span>
      </div>
      <div>
        <v-row>
          <v-col cols="12" class="d-flex justify-space-between">
            <span>
              Date: {{ overlap.startDate | formatDate }} -
              <span v-if="overlap.endDate">
                {{ overlap.endDate | formatDate }}
              </span>
              <span v-else> No End Date </span>
            </span>
            <span>
              Time: {{ overlap.startTime | formatJustTime }} -
              {{ overlap.endTime | formatJustTime }}
              <div v-if="overlap.recurring && overlap.daysOfWeek">
                Every {{ overlap.daysOfWeek.join(", ") }}
              </div>
            </span>
          </v-col>
          <v-col cols="12" >
            Will overlap on the following dates: 
          </v-col>
          <v-col cols="4" v-for="date in overlap.overlappingDates" :key="date">
            {{ date | formatDate }}
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    schedule: {
      type: Object,
      required: true,
    },
    student: {
      type: Object,
      required: true,
    },
    teacher: {
      type: Object,
      required: true,
    },
  },
  filters: {
    formatJustTime(value) {
      if (!value) return "";
      const date = new Date(`1970-01-01T${value}Z`);
      return new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      }).format(date);
    },
  },

  data: () => ({
    overlappingSchedules: [],
    student: null,
    teacher: null,
  }),
  created() {
    this.overlappingSchedules = this.value;
  },
};
</script>

<style>
.overlapping-schedule-container {
  max-width: 500px; /* You can adjust the width as needed */
  margin: 16px auto;
}
</style>
